module.exports = __webpack_public_path__ + "static/media/icon-piscine.0687bde2.svg";